export const SignupSteps = {
  PersonalDetails: "PersonalDetails",
  SecuritySetup: "SecuritySetup",
  VerifyIdentity: "VerifyIdentity",
  Suitability: "Suitability",
  TradingAccount: "TradingAccount",
  TermsConditions: "TermsConditions",
  Funding: "Funding",
  Email: "Email",
  VerifyEmail: "VerifyEmail",
  Name: "Name",
  PhoneNumber: "PhoneNumber",
  VerifyPhoneNumber: "VerifyPhoneNumber",
  Password: "Password",
};

export const MinimumPasswordLength = 8;
export const PasswordRegex =
  "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$";
